import { render, staticRenderFns } from "./addWork.vue?vue&type=template&id=7412e718&scoped=true&"
import script from "./addWork.vue?vue&type=script&lang=js&"
export * from "./addWork.vue?vue&type=script&lang=js&"
import style0 from "./addWork.vue?vue&type=style&index=0&id=7412e718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7412e718",
  null
  
)

export default component.exports